'use strict';

import React, { Component } from 'react';
import $ from 'jquery';

import ProfileAboutItemHouse from './userProfile/profile-about-itemHouse.jsx';
import ProfileAboutItemPerso from './userProfile/profile-about-itemPerso.jsx';
import ProfileBoxItemBoxStatus from './userProfile/profile-box-itemBoxStatus.jsx';

class userProfile extends Component{
    state = {
            //Initiate Time for the chart
            name: '',
            phone: '',
            email: '',
            country: '',
            MenuHouseInfoStatus: 'dropdown',
            HouseInfoStatus: 'pmb-block',
            address: '',
            city: '',
            tabInfo: 'active waves-effect',
            tabBox: 'waves-effect',
            area: '',
            idBox: '',
            addressMac: '',
            ipAdress: '',
            status: '',
            version: '',
            lastConnexion: '',
            dateOfBuilding: '',
            nbocupency: '',
            appartmentType: '',
            appartmentStatus: '',
            postcode: ''
        }
    showTabInfo= (e) => {
        e.preventDefault();
        if (this.state.tabInfo === 'waves-effect') {
            this.setState({tabInfo: 'active waves-effect', tabBox: 'waves-effect'});
        }
    }
    showTabBox= (e) => {
        e.preventDefault();
        if (this.state.tabBox === 'waves-effect') {
            this.setState({tabInfo: 'waves-effect', tabBox: 'active waves-effect'});
        }
    }
    reloadInfo= () => {
        this.updateUserInfo();
    }
    updateUserInfo= () => {
        var methodName = 'userProfile -- updateUserInfo';
        var url = "/user/info/general";

        this.serverRequest = $.get(url, function(result) {
            console.log('[INFO],' + methodName + ',  reception front des données appartement ');
            console.log(result);
            var email = '';
            var name = '';
            var phone = '';

            try {
                email = result.email;
                name = result.name;
                phone = result.phone;
                console.log(email);

            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                return;
            }

            console.log("Information Receive");
            this.setState({email: email, phone: phone, name: name});

        }.bind(this));
    }
    updateBoxInfo= () => {

        var methodName = 'userProfile -- updateBoxInfo';
      //Récupéraiton des données de la box
      var urlBox = "/user/info/box";

      this.serverRequestBox = $.get(urlBox, function(result) {

          console.log('[INFO],' + methodName + ',  reception front des données box ');
          console.log(result);
          var idBox = '';
          var addressMac = '';
          var ipAdress = '';
          var status = '';
          var version = '';
          var lastConnexion = '';

          try {
              idBox = result.idBox;
              addressMac = result.addressMac;
              ipAdress = result.ipAdress;
              status = result.status;
              version = result.version;
              lastConnexion = result.lastConnexion;
              console.log(idBox);

          } catch (e) {
              // les instructions utilisées pour gérer les
              // exceptions
              console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
              console.log(e); // on transfère l'objet de l'exception à une méthode
              console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
              return;
          }

          console.log("Information Receive For Box");
          this.setState({
              idBox: idBox,
              addressMac: addressMac,
              ipAdress: ipAdress,
              status: status,
              version: version,
              lastConnexion: lastConnexion
          });

      }.bind(this));
    }
    updatePropertyInfo= () => {
      var methodName = 'userProfile -- updatePropertyInfo';
      //Récupéraiton des données du logement
      var urlLogement = "/user/info/housing";

      this.serverRequestAppartment = $.get(urlLogement, function(result) {

          console.log('[INFO],' + methodName + ',  reception front des données appartement ');
          console.log(result);
          var area = '';

          try {
              area = result.area;
              console.log(area);
              console.log("Information Receive For Appartement");
              this.setState({
                  area: area,
                  dateOfBuilding: result.dateOfBuilding,
                  nbocupency: result.nbocupency,
                  appartmentType: result.appartmentType,
                  appartmentStatus: result.appartmentStatus,
                  city: result.city,
                  postcode: result.postcode,
                  country: result.country
              });

          } catch (e) {
              // les instructions utilisées pour gérer les
              // exceptions
              console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
              console.log(e); // on transfère l'objet de l'exception à une méthode
              console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
              return;
          }

      }.bind(this));
    }
    componentDidMount() {
        var methodName = 'userProfile';
        this.updateUserInfo();
        this.updatePropertyInfo();
        this.updateBoxInfo();

    }
    componentWillUnmount() {
        this.serverRequest.abort();
        this.serverRequestAppartment.abort();
        this.serverRequestBox.abort();
    }

    render() {
        console.log('[INFO], render fonction user Profile');

        return (
            <div className="container">
                <div className="block-header">
                    <h2>Mes Informations
                        <small></small>
                    </h2>

                    <ul className="actions m-t-20 hidden-xs"></ul>
                </div>

                <div className="card" id="profile-main">
                    <div className="pm-overview c-overflow">
                        <div className="pmo-pic">
                            <div className="p-relative">
                                <a href="">
                                    <img className="img-responsive" src="/img/profile-pics/myjBox.jpg" alt=""/>
                                </a>

                                {/*<a href="" className="pmop-edit">
                                            <i className="zmdi zmdi-camera"></i> <span className="hidden-xs">Update Profile Picture</span>
                                        </a>*/}
                            </div>

                            <div className="pmo-stat">
                                <h2 className="m-0 c-white">..</h2>
                                {this.state.name}
                            </div>
                        </div>

                        <div className="pmo-block pmo-contact hidden-xs">
                            <h2>Contact</h2>

                            <ul>
                                <li>
                                    <i className="zmdi zmdi-phone"></i>
                                    {this.state.phone}</li>
                                <li>
                                    <i className="zmdi zmdi-email"></i>
                                    {this.state.email}</li>
                                <li>
                                    <i className="zmdi zmdi-pin"></i>
                                    <address className="m-b-0">
                                        {this.state.postcode},
                                        <br/> {this.state.city},
                                        <br/> {this.state.country}
                                    </address>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="pm-body clearfix">
                        <ul className="tab-nav tn-justified">
                            <li className={this.state.tabInfo} onClick={this.showTabInfo}>
                                <a href>Vos informations</a>
                            </li>
                            <li className={this.state.tabBox} onClick={this.showTabBox}>
                                <a href>Votre Energy Manager</a>
                            </li>
                            {/*<li className="waves-effect"><a href="profile-photos.html">Votre Energy Manager</a></li>
                                    <li className="waves-effect"><a href="profile-connections.html">Connections</a></li>*/}
                        </ul>
                        {(() => {
                            if (this.state.tabBox === 'waves-effect') {
                                return (
                                    <div><ProfileAboutItemHouse area={this.state.area} dateOfBuilding={this.state.dateOfBuilding} nbocupency={this.state.nbocupency} AppartmentStatus={this.state.appartmentStatus} AppartmentType={this.state.appartmentType} country={this.state.country} city={this.state.city} postcode={this.state.postcode} reloadInfo={this.updatePropertyInfo}/>
                                        <ProfileAboutItemPerso name={this.state.name} phone={this.state.phone} email={this.state.email} country={this.state.country} reloadInfo={this.updateUserInfo}/></div>
                                );
                            } else {
                                return (<ProfileBoxItemBoxStatus idBox={this.state.idBox} addressMac={this.state.addressMac} ipAdress={this.state.ipAdress} status={this.state.status} version={this.state.version} lastConnexion={this.state.lastConnexion} reloadInfo={this.updateBoxInfo}/>);
                            }
                        })()}

                    </div>
                </div>
            </div>
        );
    }
};

export default userProfile

//module.exports = userProfile;
